import axios from "axios";

export const TOKEN_KEY = "sp_token";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("sp-auth-expired"));
    }
    return Promise.reject(error);
  }
);

export const errorMessage = (e, fallback = "Si è verificato un errore") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ") || fallback;
  if (d.message) return d.message;
  if (typeof d.msg === "string") return d.msg;
  return fallback;
};
